import { LeaveCreditKind, type LeaveType } from '../leaveTypes';

/** `YYYY-MM-DD`, built from the parts so no instant conversion can shift the day. */
function calendarDate(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

/**
 * A plausible approved leave, every field filled so the row produces a readable preview.
 *
 * **The type comes from the LIVE catalog**, which is why it is an argument: a parameterless
 * generator fills no foreign key. A type that can be deducted from is preferred, so the sample
 * exercises the ledger write; the deduction choice itself is filled as that answer.
 */
export function sampleLeaveRecord(types: LeaveType[], approverUserId: string | null) {
  const type =
    types.find((t) => t.creditKind === LeaveCreditKind.Ledger) ?? types[0] ?? null;

  // Last week, Monday to Wednesday: three working days, filed and approved the week before.
  const today = new Date();
  const monday = new Date(today);
  monday.setDate(today.getDate() - ((today.getDay() + 6) % 7) - 7);
  const wednesday = new Date(monday);
  wednesday.setDate(monday.getDate() + 2);
  const filed = new Date(monday);
  filed.setDate(monday.getDate() - 7);
  const approved = new Date(monday);
  approved.setDate(monday.getDate() - 5);

  return {
    leaveTypeId: type?.id ?? '',
    startDate: calendarDate(monday),
    endDate: calendarDate(wednesday),
    days: '3',
    deductsCredit: type?.creditKind === LeaveCreditKind.Ledger,
    filedDate: calendarDate(filed),
    reason: 'Sample leave — to attend to a family matter.',
    approvedByUserId: approverUserId,
    approvedDate: calendarDate(approved),
    approvalRemarks: 'Sample approval — duly recommended by the immediate supervisor.',
  };
}
